import React from 'react';

export const lastTradePrice = {
    body: <span>Last Trade Price</span>,
};

export const pnc = {
    body: <span>Previous Night&apos;s Close</span>,
};
